import { Link } from "react-router-dom";

import { COMPANY } from "../legal/content.generated";

// Schlanker globaler Footer (App + Demo) mit den Rechts-Links.
export default function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-slate-500 sm:flex-row sm:px-6">
        <p>
          © {year} TruuCost · {COMPANY.legalName}
        </p>
        <nav className="flex items-center gap-4" aria-label="Rechtliches">
          <Link to="/impressum" className="hover:text-slate-900">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-slate-900">
            Datenschutz
          </Link>
        </nav>
      </div>
    </footer>
  );
}
